import BurgerMenuContainer from './BurgerMenu.container';
import BurgerMenu from './BurgerMenu';
import BurgerMenuExperimental from './BurgerMenu.experimental_body_scroll_lock';
import { withFeatureBranch } from '../../../redux/flags';
export default BurgerMenuContainer(withFeatureBranch({ experimental_body_scroll_lock: BurgerMenuExperimental })(BurgerMenu));
//# sourceMappingURL=index.js.map